import React, { useContext } from "react";
import { FormProvider, useForm } from "react-hook-form";
import TextInput from "components/shared/form/fields/TextInput";
import FormActions from "components/shared/form/fields/FormActions";
import { NewInviteContext } from "components/administration/invites/NewInvitePage";
import { includes, map, omit } from "lodash";
import DirectoryPickerInput from "components/shared/form/fields/DirectoryPickerInput";
import SharedInviteFieds from "components/administration/invites/SharedInviteFields";
import { ExternalInviteArgs } from "components/administration/invites/types";
import InviteErrors from "components/administration/invites/InviteErrors";

type FormArgs = {
  email: string;
  first_name: string;
  last_name: string;
  subject: string;
  body: string;
  user_type?: "normal" | "external";
  groups?: { id: string }[];
  channels?: { id: string }[];
};

export default function ExternalInviteForm({
  inviteExternal,
  defaultValues,
  errors,
}: ExternalInviteArgs) {
  const context: any = useContext(NewInviteContext);

  const methods = useForm<FormArgs>({
    defaultValues,
  });
  const { handleSubmit } = methods;

  function submit(data: FormArgs) {
    const group_ids = map(data.groups, "id");
    const channel_ids = map(data.channels, "id");

    inviteExternal({
      external_invite: {
        ...omit(data, ["groups", "channels"]),
        group_ids,
        channel_ids,
      },
    });
  }

  return (
    <FormProvider {...methods}>
      <form className="form-horizontal" onSubmit={handleSubmit(submit)}>
        <div className="text-muted my-4">
          {context?.type === "network" || context?.type === "group_category"
            ? I18n.t("js.invites.external_network_invite_hint")
            : I18n.t("js.invites.external_group_invite_hint")}
        </div>
        <InviteErrors {...errors} />
        <TextInput name="email" label={I18n.t("js.invites.email")} required />
        <TextInput name="first_name" label={I18n.t("js.invites.first_name")} />
        <TextInput name="last_name" label={I18n.t("js.invites.last_name")} />
        <SharedInviteFieds />
        {(context?.type === "network" ||
          context?.type === "group_category") && (
          <>
            <DirectoryPickerInput
              label={I18n.t("js.invites.groups")}
              name="groups"
              query={{
                groups_only: true,
                exclude_sensitive_groups: true,
                context: context?.type === "group_category" ? context.id : null,
              }}
              placeholder="Gruppen suchen..."
              showDefaultOptions={false}
              multi
            />
            {includes(Preload.current_network.availableModules, "Channels") && (
              <DirectoryPickerInput
                label={I18n.t("js.invites.channels")}
                name="channels"
                endpoint="/directory/channels"
                showDefaultOptions={false}
                multi
              />
            )}
          </>
        )}
        <FormActions
          saveText={I18n.t("js.invites.submit")}
          showCancel={false}
        />
      </form>
    </FormProvider>
  );
}
